import {writable, derived} from 'svelte/store';
import rpcjs from 'rpcjs';

const {apiInit, persistent} = rpcjs.props;


export const successStories = derived(
    apiInit,
    ($apiInit, set) => {
        if ($apiInit) {
            rpcjs.API.Draper.get_success_stories().then((r) => set(r));
        }
    }, [],
);

export const animationPlayedOn = persistent('animation_played_on');
export const playAnimation = derived(
    animationPlayedOn,
    ($animationPlayedOn, set) => {
        if ($animationPlayedOn) {
            const today = new Date();
            const animation = new Date($animationPlayedOn);
            const diffYear = today.getFullYear() - animation.getFullYear();
            if (diffYear==0) {
                const diff = today.getMonth() - animation.getMonth();
                if (diff>1) {
                    set(true);
                } else {
                    set(false);
                }
            } else {
                set(true);
            }
        } else {
            set(true);
        }
    }, true,
);

export const HeroForm = persistent('HeroForm');

export const showThankUPopUp = writable(0);
